import { Separator } from '@monksflow/monks-ui';
import clsx from 'clsx';

interface SectionSeparatorProps {
  /**
   * A rule between sub-sections sits back at 30% of `border-light`. One dividing content
   * inside a card has to hold its own against the card's border, so it takes the solid
   * `border` step rather than a fainter wash of an already-pale token.
   */
  emphasis?: 'section' | 'card';
}

/**
 * Divider between sub-sections of an IQ analysis section.
 *
 * Owns the colour and weight of the rule so every divider in the report reads the
 * same. Vertical spacing still comes from the parent's `gap`, which each section
 * sets; keeping it there means a section can breathe wider without this component
 * fighting it, but it does mean sections must agree on that gap to look alike.
 */
export const SectionSeparator = ({ emphasis = 'section' }: SectionSeparatorProps = {}) => (
  <Separator
    variant={emphasis === 'card' ? 'medium' : 'light'}
    className={clsx(emphasis === 'section' && 'opacity-30')}
    data-testid="section-separator"
  />
);
